import { ApisauceInstance, ApiResponse } from 'apisauce';

const getGroupMemberships = (
  api: ApisauceInstance,
  groupId: string,
): Promise<ApiResponse<{ users: MicrosoftSso.User[] }>> =>
  api.get<{ users: MicrosoftSso.User[] }>(
    `/v1/sso/microsoft/groups/${groupId}`,
  );

export default getGroupMemberships;
